import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { fullRoutes } from './shared/routes/full-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';

import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { LoginPageComponent } from './pages/content-pages/login/login-page.component';
import { HomefirstScoresModule } from './homefirst-scores/homefirst-scores.module';
import { AsianPaintsModule } from './asian-paints/asian-paints.module';
import { CocaColaValuesGameModule } from './coca-cola-values-game/coca-cola-values-game.module';
import { CocaColaValuesGameHccbModule } from './coca-cola-values-game-hccb/coca-cola-values-game-hccb.module';
import { AsianPaintsGlobetrotterComponent } from './asian-paints-globetrotter/asian-paints-globetrotter.component';

// import { LoginPageComponent } from './pages/content-pages/login/login-page.component';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'games/lv1/characters',
  //   pathMatch: 'full',
  //   canActivate: [AuthGuard],
  // },
  {
    path: '',
    component: FullLayoutComponent,
    data: { title: 'full Views' },
    children: fullRoutes,
  },
  {
    path: '',
    component: ContentLayoutComponent,
    data: { title: 'content Views' },
    children: CONTENT_ROUTES,
  },
  {
    path: 'login',
    component: LoginPageComponent,
    pathMatch: 'full',
  },
  {
    path: 'HomeFirst',
    loadChildren: () => HomefirstScoresModule,
    pathMatch: 'full',
  },
  {
    path: 'asian-paints-values',
    loadChildren: () => AsianPaintsModule,
    pathMatch: 'full',
  },
  {
    path: 'coca-cola-values-game',
    loadChildren: () => CocaColaValuesGameModule,
    pathMatch: 'full',
  },
  {
    path: 'coca-cola-values-game-hccb',
    loadChildren: () => CocaColaValuesGameHccbModule,
    pathMatch: 'full',
  },
  {
    path: 'asian-paints-globetrotter-challenge-integrity',
    component: AsianPaintsGlobetrotterComponent,
    pathMatch: 'full',
  },

  {
    path: '**',
    redirectTo: 'pages/error',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
